const STORAGE_KEY = 'enchliving:online-store-only';
const BODY_CLASS = 'enchliving-online-store-only';
const OPTION_SELECTOR = '[data-enchliving-exclusive-option]';

function isCollectionPage() {
  return document.body.getAttribute('data-page-type') === 'collection';
}

function getConfig() {
  return window.__enchlivingCatalogConfig || { defaultActive: true, forceDefault: false };
}

function applyState(active) {
  if (isCollectionPage()) {
    document.body.classList.toggle(BODY_CLASS, active);
  } else {
    document.body.classList.remove(BODY_CLASS);
  }

  try {
    localStorage.setItem(STORAGE_KEY, active ? '1' : '0');
  } catch (e) {
  }

  document.querySelectorAll(OPTION_SELECTOR).forEach((btn) => {
    const mode = btn.getAttribute('data-enchliving-exclusive-option');
    const isThisActive = mode === 'online' ? active : !active;
    btn.classList.toggle('is-active', isThisActive);
    btn.setAttribute('aria-pressed', isThisActive ? 'true' : 'false');
  });
}

function getInitialState() {
  const config = getConfig();

  try {
    const params = new URLSearchParams(window.location.search);
    const forced = params.get('ench_catalog');
    if (forced === 'online' || forced === 'all') {
      const forcedActive = forced === 'online';
      try {
        localStorage.setItem(STORAGE_KEY, forcedActive ? '1' : '0');
      } catch (e) {
      }
      try {
        params.delete('ench_catalog');
        const qs = params.toString();
        const newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
        window.history.replaceState({}, '', newUrl);
      } catch (e) {
      }
      return forcedActive;
    }
  } catch (e) {
  }

  if (config.forceDefault) {
    return !!config.defaultActive;
  }

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === '0' || stored === '1') {
      return stored === '1';
    }
  } catch (e) {
  }

  return !!config.defaultActive;
}

function init() {
  if (window.__enchlivingExclusiveSwitchInit) return;
  window.__enchlivingExclusiveSwitchInit = true;

  applyState(getInitialState());

  document.addEventListener('click', (e) => {
    const btn = e.target.closest(OPTION_SELECTOR);
    if (!btn) return;
    e.preventDefault();
    const mode = btn.getAttribute('data-enchliving-exclusive-option');
    const active = mode === 'online';
    applyState(active);
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-enchliving-mobile-exclusive-toggle]');
    if (!input) return;
    applyState(!!input.checked);
  });

  document.addEventListener('click', function (e) {
    try {
      const found = e.target.closest(OPTION_SELECTOR);
      if (found) {
      }
    } catch (err) {}
  }, true);

  document.addEventListener('pointerdown', function (e) {
    try {
      const found = e.target.closest(OPTION_SELECTOR);
      if (found) {
      }
    } catch (err) {}
  }, true);

  function attachButtonListeners(btn) {
    if (!btn || btn.__enchExclusiveAttached) return;
    btn.__enchExclusiveAttached = true;
    const handler = function (e) {
      try {
        e.preventDefault();
      } catch (_) {}
      const mode = btn.getAttribute('data-enchliving-exclusive-option');
      const active = mode === 'online';
      applyState(active);
    };
    btn.addEventListener('click', handler);
    btn.addEventListener('pointerdown', function () {}, { passive: true });
  }

  function attachAllButtons() {
    document.querySelectorAll(OPTION_SELECTOR).forEach(attachButtonListeners);
  }

  const obs = new MutationObserver(function (mutations) {
    let added = false;
    for (const m of mutations) {
      if (!m.addedNodes) continue;
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches(OPTION_SELECTOR)) {
          attachButtonListeners(n);
          added = true;
        }
        if (n.querySelectorAll) {
          const found = n.querySelectorAll(OPTION_SELECTOR);
          if (found.length) {
            found.forEach(attachButtonListeners);
            added = true;
          }
        }
      });
    }
    if (added) {
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });

  attachAllButtons();

  document.addEventListener('facet:updated', () => {
    applyState(getInitialState());
  });

  document.addEventListener('dialog:after-show', () => {
    applyState(getInitialState());
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
